import { usePostTimeTable } from './usePostTimeTable';

export const useClickGenerate = () => {
	const { appendDataPost } = usePostTimeTable();
	const appendDataGenerate = ( timetable ) => {
		
		appendDataPost( timetable );
	};

	return { appendDataGenerate };
};
